import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";
import { useSite } from "@/hooks/useSite";
import { trackEvent } from "@/lib/analytics";

export default function CTA() {
  const site = useSite();
  const wa = (site?.whatsapp || "").replace(/[^\d]/g, "");
  const waHref = wa ? `https://wa.me/${wa}?text=${encodeURIComponent("Hola, me gustaría conversar sobre una consultoría con KB.")}` : "#contacto";

  return (
    <section className="relative py-32 md:py-48 border-t border-[#1A1A1A]/10" data-testid="cta-section">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10 text-center">
        <Reveal>
          <div className="eyebrow mb-6">— Llamada a la acción</div>
          <h2 className="font-serif text-[clamp(2.5rem,8vw,7rem)] leading-[0.95] tracking-[-0.02em] max-w-5xl mx-auto">
            ¿Está listo para <em className="italic text-[#1B3B2B]">fortalecer</em>
            <br className="hidden sm:block" />
            su organización?
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-10 max-w-2xl mx-auto text-[#4A4A4A] leading-relaxed">
            Conversemos sobre sus necesidades y construyamos una solución adaptada a sus objetivos, procesos y recursos.
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <div className="mt-14 flex flex-wrap justify-center gap-3">
            <a href="#contacto" className="kb-btn" data-testid="cta-primary">
              Solicitar una asesoría <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
            <a href={waHref} onClick={() => trackEvent("whatsapp_click", { source: "main_cta" })} target="_blank" rel="noreferrer" className="kb-btn ghost" data-testid="cta-whatsapp">
              Contactar por WhatsApp
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
